/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindOneStepQueryResponse, DocumentsControllerFindOneStepPathParams, DocumentsControllerFindOneStep400, DocumentsControllerFindOneStep401, DocumentsControllerFindOneStep403, DocumentsControllerFindOneStep404 } from "../../models/documentsController/DocumentsControllerFindOneStep";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFindOneStep } from "../../clients/documentsService/documentsControllerFindOneStep";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFindOneStepQueryKey = (id: DocumentsControllerFindOneStepPathParams["id"], processingId: DocumentsControllerFindOneStepPathParams["processingId"], stepId: DocumentsControllerFindOneStepPathParams["stepId"]) => [{
  url: '/api/v1/documents/:id/processing/:processingId/steps/:stepId',
  params: {
    id: id,
    processingId: processingId,
    stepId: stepId
  }
}] as const;
export type DocumentsControllerFindOneStepQueryKey = ReturnType<typeof documentsControllerFindOneStepQueryKey>;
export function documentsControllerFindOneStepQueryOptions(id: DocumentsControllerFindOneStepPathParams["id"], processingId: DocumentsControllerFindOneStepPathParams["processingId"], stepId: DocumentsControllerFindOneStepPathParams["stepId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFindOneStepQueryKey(id, processingId, stepId);
  return queryOptions<DocumentsControllerFindOneStepQueryResponse, ResponseErrorConfig<DocumentsControllerFindOneStep400 | DocumentsControllerFindOneStep401 | DocumentsControllerFindOneStep403 | DocumentsControllerFindOneStep404>, DocumentsControllerFindOneStepQueryResponse, typeof queryKey>({
    enabled: !!(id && processingId && stepId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFindOneStep(id, processingId, stepId, config);
    }
  });
}

/**
 * @summary Get a specific processing step
 * {@link /api/v1/documents/:id/processing/:processingId/steps/:stepId}
 */
export function useDocumentsControllerFindOneStep<TData = DocumentsControllerFindOneStepQueryResponse, TQueryData = DocumentsControllerFindOneStepQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFindOneStepQueryKey>(id: DocumentsControllerFindOneStepPathParams["id"], processingId: DocumentsControllerFindOneStepPathParams["processingId"], stepId: DocumentsControllerFindOneStepPathParams["stepId"], options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFindOneStepQueryResponse, ResponseErrorConfig<DocumentsControllerFindOneStep400 | DocumentsControllerFindOneStep401 | DocumentsControllerFindOneStep403 | DocumentsControllerFindOneStep404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFindOneStepQueryKey(id, processingId, stepId);
  const query = useQuery({
    ...documentsControllerFindOneStepQueryOptions(id, processingId, stepId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFindOneStep400 | DocumentsControllerFindOneStep401 | DocumentsControllerFindOneStep403 | DocumentsControllerFindOneStep404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}